import { FaLinkedin, FaGithub, FaEnvelope, FaTwitter } from 'react-icons/fa';

const dataSocials = [
    {
        name: "Linkedin",
        link: "https://www.linkedin.com/in/riste-spasov-3a24b717b/",
        icon: <FaLinkedin />
    },
    {
        name: "Github",
        link: "https://github.com/ristespasov",
        icon: <FaGithub />
    },
    {
        name: "Twitter",
        link: "https://twitter.com/RisteSpasov",
        icon: <FaTwitter />
    },
    {
        name: "Email",
        link: "mailto:ristespasov@hotmail.com",
        icon: <FaEnvelope />
    },
]

export default dataSocials